import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { TeacherEligibilityDialogBoxComponent } from '../teacher-eligibility-dialog-box/teacher-eligibility-dialog-box.component';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-teacher-eligibility',
  templateUrl: './teacher-eligibility.component.html',
  styleUrls: ['./teacher-eligibility.component.scss'],
})
export class TeacherEligibilityComponent implements OnInit {

  allTeacherEligibilityData = [];
  collegedataList = [];
  list = true;
  teacherAssignForm;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  UserCollege;
  userPermission;
  setIntervalSearch: any;
 courseLevelList: any[] = [];  



  constructor(
    public umsService: UmsService,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission") || '[]');
    this.teacherAssignForm = this.fb.group({
      SearchString: new FormControl('')
    });
    this.fetchCourseLevels(); 
    this.getTeacherEligibilityData();
  }
 fetchCourseLevels() {
  this.umsService.getCodeType({ CdType: 'COLVL' }).subscribe(res => {
    if (res.status && res.data) {
      console.log('Course Level API response:', res); 
     this.courseLevelList = res.data.map((x: any) => ({
        CdId: x.CdCode + '',      
        CdValue: x.CdDesc         
      }));

    }
  }, (error: any) => {
    console.error('Error fetching course levels', error);
    this.courseLevelList = [];
  });
}
  onPageChange(event: PageEvent): void {
  this.pageSize = event.pageSize;
  this.currentPage = event.pageIndex + 1;
  this.getTeacherEligibilityData();
}


  getTeacherEligibilityData() {
    if (this.userPermission[0]?.CgUi == 'C') {
      this.UserCollege = this.userPermission[0].CgId;
    } else {
      this.UserCollege = '';
    }
    
    this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['SearchString'] = this.teacherAssignForm.value.SearchString || '';
    payload['EligibId'] = 0;
    payload['CgCode'] = this.UserCollege;
    
    this.umsService.getTeacherEligibilityData(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        console.log('LIST DATA:', res.data);

        this.allTeacherEligibilityData = res.data;
        this.totalItems = res.data[0]?.TotalRecords || 0;
        this.applyFilters();
      } else {
        this.allTeacherEligibilityData = [];
        this.collegedataList = [];
        this.totalItems = 0;
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.allTeacherEligibilityData = [];
      this.collegedataList = [];
      this.totalItems = 0;
    });
  }

  applyFilters() {
    let data = [...this.allTeacherEligibilityData];
    
    const searchText = this.teacherAssignForm.value['SearchString']?.toLowerCase();
    if (searchText) {
      data = data.filter(item =>
        item.FcDesc?.toLowerCase().includes(searchText) ||
        item.CoName?.toLowerCase().includes(searchText) || 
        item.SubName?.toLowerCase().includes(searchText) ||
        item.Designation?.toLowerCase().includes(searchText) ||
        item.CourseLevel?.toString().toLowerCase().includes(searchText) || // Added CourseLevel search
        item.District?.toLowerCase().includes(searchText) ||
        item.TeacherType?.toLowerCase().includes(searchText) ||
        item.Experience?.toString().includes(searchText) ||
        item.Count?.toString().includes(searchText) ||
        (item.Is_Repeat !== undefined && (item.Is_Repeat ? 'yes' : 'no').includes(searchText)) ||
        (item.IsHOD !== undefined && (item.IsHOD ? 'yes' : 'no').includes(searchText)) ||
        (item.IsSameCollege !== undefined && (item.IsSameCollege ? 'yes' : 'no').includes(searchText)) ||
        (item.IsBothTeachType !== undefined && (item.IsBothTeachType ? 'yes' : 'no').includes(searchText)) ||
        (item.Guide !== undefined && (item.Guide ? 'yes' : 'no').includes(searchText))
      );
    }
    this.collegedataList = data;
  }

 keypress() {
  if (this.setIntervalSearch) {
    clearTimeout(this.setIntervalSearch);
  }

  this.setIntervalSearch = setTimeout(() => {
    this.currentPage = 1;
    this.getTeacherEligibilityData();
  }, 1000);
}


  addNewRecord() {
    const dialogRef = this.dialog.open(TeacherEligibilityDialogBoxComponent, {
      width: '90%',
      data: { key: "Add" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getTeacherEligibilityData();
      this.teacherAssignForm.controls['SearchString'].setValue('');
    });
  }

 editData(k) {
  const dialogRef = this.dialog.open(TeacherEligibilityDialogBoxComponent, {
    width: '90%',
    data: { selected: k, key: "Edit" },
    disableClose: true
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result === true) {
      this.getTeacherEligibilityData(); 
    }
  });
}

 deleteData(k) {
  const dialogRef = this.dialog.open(TeacherEligibilityDialogBoxComponent, {
    width: '90vh',
    data: { selected: k, key: "Delete" },
    disableClose: true
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result === true) {
      this.getTeacherEligibilityData();
    }
  });
}

  
  redirect(to): void {
    this.router.navigate([to]);
  }

getCourseLevelDescription(levelCode: any): string {
  if (!levelCode) return '-';
  const found = this.courseLevelList.find(lvl => lvl.CdId === levelCode.toString());
  return found ? found.CdValue : levelCode; 
}



}